import { CLICK_COOKIE_MULT_NUM, COMBO_MAX_STACKS, COMBO_PCT_PER_STACK } from "@cookies/shared/config"
import { effectiveClickPowerNum } from "@cookies/shared/economy"
import { bakerCreditsFor } from "./errors"

const CLICK_COOKIE_MULT = CLICK_COOKIE_MULT_NUM

export const effectivePower = effectiveClickPowerNum

export function comboBps(combo: number): number {
  if (!Number.isFinite(combo) || combo <= 0) return 10000
  return 10000 + Math.min(Math.floor(combo), COMBO_MAX_STACKS) * COMBO_PCT_PER_STACK * 100
}

export function comboMult(combo: number): number {
  return comboBps(combo) / 10000
}

export function previewPerClick(basePower: number, rush: boolean, golden: boolean, combo: number): { cookies: number; credits: number; nextCombo: number } {
  const eff = effectivePower(basePower)
  const nextCombo = combo > 0 ? Math.min(Math.floor(combo) + 1, COMBO_MAX_STACKS) : 1
  const mult = (rush ? 2 : 1) * (golden ? 5 : 1)
  const stepped = Math.floor((eff * mult * comboBps(nextCombo)) / 10000)
  const cookies = Math.max(1, stepped * CLICK_COOKIE_MULT)
  return { cookies, credits: bakerCreditsFor(cookies), nextCombo }
}

export { CLICK_COOKIE_MULT }
